import { render } from "./DashboardRanking.vue?vue&type=template&id=6f747585&scoped=true"
import script from "./DashboardRanking.vue?vue&type=script&lang=js"
export * from "./DashboardRanking.vue?vue&type=script&lang=js"

import "./DashboardRanking.vue?vue&type=style&index=0&id=6f747585&scoped=true&lang=css"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f747585"]])

export default __exports__